module.exports = __webpack_public_path__ + "img/gate-rail-vertical-left.722b5ef0.png";